import _ from 'lodash';

import { createApiReducer } from 'src/api';

import {
  FETCH_ACCOUNT_VENDORS_START,
  FETCH_ACCOUNT_VENDORS_SUCCESS,
  FETCH_ACCOUNT_VENDORS_FAILURE,
  ADD_ACCOUNT_VENDOR_START,
  ADD_ACCOUNT_VENDOR_SUCCESS,
  ADD_ACCOUNT_VENDOR_FAILURE,
  DELETE_ACCOUNT_VENDOR_START,
  DELETE_ACCOUNT_VENDOR_SUCCESS,
  DELETE_ACCOUNT_VENDOR_FAILURE,
} from './actions';

let transformVendor = null;

export const setTransformVendor = dataAdapter => {
  transformVendor = dataAdapter;
};

export const getTransformVendor = () => transformVendor;

const accountFetchVendorsReducer = createApiReducer(
  [
    FETCH_ACCOUNT_VENDORS_START,
    FETCH_ACCOUNT_VENDORS_SUCCESS,
    FETCH_ACCOUNT_VENDORS_FAILURE,
  ],
  (payload, state) => {
    return {
      ...state.data,
      vendors: payload.map(v => ({
        ...transformVendor(v.vendor_account_vendor),
        addedAt: v.vendor_account_added_date,
      })),
    };
  },
  error => transformVendor(_.get(error, 'payload.response', {}))
);

const accountAddVendorReducer = createApiReducer(
  [
    ADD_ACCOUNT_VENDOR_START,
    ADD_ACCOUNT_VENDOR_SUCCESS,
    ADD_ACCOUNT_VENDOR_FAILURE,
  ],
  (payload, state) => {
    return {
      ...state.data,
      vendors: [
        ...state.data.vendors,
        {
          ...transformVendor(payload.vendor_account_vendor),
          addedAt: payload.vendor_account_added_date,
        },
      ],
    };
  },
  error => transformVendor(_.get(error, 'payload.response', {}))
);

const accountDeleteVendorReducer = createApiReducer(
  [
    DELETE_ACCOUNT_VENDOR_START,
    DELETE_ACCOUNT_VENDOR_SUCCESS,
    DELETE_ACCOUNT_VENDOR_FAILURE,
  ],
  (payload, state) => {
    return {
      ...state.data,
      vendors: state.data.vendors.filter(
        v => v.id !== payload.vendor_account_vendor.id
      ),
    };
  },
  error => transformVendor(_.get(error, 'payload.response', {}))
);

export const reducers = [
  accountFetchVendorsReducer,
  accountAddVendorReducer,
  accountDeleteVendorReducer,
];
